import {
  DocSorterFileStatusEnum,
  GetAllFilesApiV1FilesGetData,
  ReportGeneratorTemplateResponseStatusEnum,
} from "@/api/generated/types.gen";
import { DOCUMENT_CLASSIFICATIONS } from "@/constants/documents";

export const DOCUMENT_TYPES_OPTIONS = DOCUMENT_CLASSIFICATIONS.map((item) => ({
  value: item.category,
  label: item.title,
}));

export const DOCUMENT_STATUS_OPTIONS: {
  value: DocSorterFileStatusEnum;
  label: string;
}[] = [
  { value: "TO_BE_PROCESSED", label: "To Be Processed" },
  { value: "PROCESSING", label: "Processing" },
  { value: "COMPLETED", label: "Completed" },
  { value: "EXPORTING", label: "Exporting" },
  { value: "EXPORTED", label: "Exported" },
  { value: "FAILED", label: "Failed" },
];

export const REPORT_STATUS_OPTIONS: {
  value: ReportGeneratorTemplateResponseStatusEnum;
  label: string;
}[] = [
  { value: "TO_BE_PROCESSED", label: "To Be Processed" },
  { value: "PROCESSING", label: "Processing" },
  { value: "COMPLETED", label: "Completed" },
  { value: "FAILED", label: "Failed" },
];

export const SORTING_ORDER_OPTIONS: {
  value: NonNullable<GetAllFilesApiV1FilesGetData["query"]>["sort_by"];
  label: string;
}[] = [
  { value: "recently_added", label: "Recently Added" },
  { value: "recently_updated", label: "Recently Updated" },
  { value: "oldest", label: "Oldest" },
];
